import moment from 'moment';

import { requestApi } from 'api/Api';

import { ia } from 'lib/helpers/utility';

export const updatePayerOrder = async ({ patientId, setClaim = () => {}, practiceId, event }) => {
  const selectedValue = event?.value;
  if (selectedValue === 'primary') {
    setClaim((prevClaim) => ({
      ...prevClaim,
      payer_order: selectedValue,
      other_ins_name_l: '',
      other_ins_name_f: '',
      other_ins_name_m: '',
      other_ins_number: '',
      other_ins_dob: '',
      other_pat_rel: '',
      other_payer_name: '',
      other_payerid: ''
    }));
    return;
  }

  const res = await requestApi({
    url: '/api/insurance_profiles/get',
    params: { userId: patientId, practiceId }
  });

  let insurance = [];
  if (ia(res?.insuranceProfile)) {
    insurance = res?.insuranceProfile?.filter((ins) => ins?.type === selectedValue);
  }

  if (ia(insurance)) {
    const insuranceData = insurance[0];
    setClaim((prevClaim) => ({
      ...prevClaim,
      payer_order: selectedValue,
      other_ins_name_l: insuranceData?.insured_last_name || null,
      other_ins_name_f: insuranceData?.insured_first_name || null,
      other_ins_name_m: insuranceData?.insured_middle_name || null,
      other_ins_number: insuranceData?.member_id || null,
      other_ins_dob: moment(insuranceData?.insured_date_of_birth).format('YYYY-DD-MM') || null,
      other_pat_rel: insuranceData?.relation || null,
      other_payer_name: insuranceData?.payer_name || null,
      other_payerid: insuranceData?.payer_id || null
    }));
  } else {
    setClaim((prevClaim) => ({
      ...prevClaim,
      payer_order: selectedValue
    }));
  }
};
